import React, { useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje} from "../../mensajes2";
import {
  formatMoneda,
} from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import TablaHistoricosInmuebles from "./tablaHistoricoInmuebe";
import TablaDeudaInmueble from "./tablaDeudaInmueble";
import TablaFacturasInmuebles from "./tablaFacturaInmuebles";
import { Dimmer } from "../../spinner";
import { DangerButton, InfoButton } from "../../../ui/buttons/Button";
import { Input } from "../../../ui/inputs/Input";

export const EstadoCuentaInmuebleModal = (props) => {

  let op = require("../../../../src/modulos/datos");
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [factorCambio, setFactorCambio] = useState(0);
  const [activate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [status, setStatus] = useState();

  const imprimirRelacionPago = () => (event) => {
    event.preventDefault();
    var reporte = "Planillacontricomercio";
    var idinmueble = props.inmueble.idinmueble;
    window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&id=" + idinmueble +  "&tipo=(2,34,69)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  };
  const imprimirDeudaGeneral = () => (event) => {
    var reporte = "Hac_DeudaGeneral";
    var cedpropie = props.inmueble && props.inmueble.cedulapropie;
    const rif = props.body ? props.body?.rif : cedpropie
    window.open(
      op.reportes +
      "/actividadeconomica?" +
      "reporte=" +
      reporte +
      `&sql='${rif.trim()}'` +
      "&rif=" +
        `'${cedpropie.trim()}'` +
        "&cedula=" +
        `'${cedpropie.trim()}'`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );

  };
  const salir = () => {
    props.onHideCancela();
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setFactorCambio(props.factorCambio);
        setStatus(
          props.inmueble
            ? props.inmueble.status !== "61"
              ? "INACTIVO"
              : "ACTIVO"
            : ""
        );
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Estado Cuenta."
            : operacion === 2
            ? "Editar Estado Cuenta."
            : operacion === 3
            ? "Eliminar Estado Cuenta."
            : "Detalles de Deuda de Propiedad Inmoboiliaria."}
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="text-light fw-bold fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i> 
        </a>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded d-flex flex-wrap">
          <legend className="float-none w-auto m-0">
            Deuda Contribuyente Propiedad inmobiliaria
          </legend>
          <div className="col-2 m-0 p-0">
            <Input label = 'Código:'
              disabled
              defaultValue={
                props.inmueble
                  ? props.inmueble.idinmueble !== null
                    ? props.inmueble.idinmueble.trim()
                    : ""
                  : ""
              }
            />
          </div>
          <div className="col-2 m-0 p-0 pl-2">
            <Input label = 'RITM:'
              disabled
              defaultValue={
                props.inmueble
                  ? props.inmueble.ritm !== null
                    ? props.inmueble.ritm.trim()
                    : ""
                  : ""
              }
            />
          </div>
          <div className="col-3 m-0 p-0 pl-2">
            <Input label = 'Nº de Inscripcion:'
              disabled
              defaultValue={
                props.inmueble
                  ? props.inmueble.numinscripcion !== null
                    ? props.inmueble.numinscripcion.trim()
                    : ""
                  : ""
              }
            />
          </div>
          <div className="col-2 m-0 p-0 pl-2">
            <Input label = 'Status:'
              disabled
              defaultValue={status}
            />
          </div>
          <div className="col-3 m-0 p-0 pl-2 text-center">
            Valor Euro €:
            {formatMoneda(
              factorCambio.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            )}
          </div>
          <div className="col-9 m-0 my-2 p-0">
            <Input label = 'Nombre Propietario:'
              disabled
              defaultValue={props.inmueble
                ? props.inmueble.nombrepropie !== null
                  ? props.inmueble.nombrepropie.trim()
                  : ""
                : ""}
            />
          </div>
          <div className="col-3 m-0 my-2 p-0 pl-2">
            <Input label = 'C.I./ R.I.F:'
              disabled
              defaultValue={props.inmueble
                ? props.inmueble.cedulapropie !== null
                  ? props.inmueble.cedulapropie.trim()
                  : ""
                : ""}
            />
          </div>
          <div className="col-12 m-0 p-0">
            <Input label = 'Dirección del inmueble:'
              disabled
              defaultValue={props.inmueble
                ? props.inmueble.dirinmueble !== null
                  ? props.inmueble.dirinmueble.trim()
                  : ""
                : ""}
            />
          </div>
        </fieldset>
        <ul className="nav" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className=" rounded nav-link active bg-blue-100 text-light"
              id="datosTributarios"
              data-bs-toggle="tab"
              data-bs-target="#tributarios"
              type="button"
              role="tab"
              aria-controls="tributarios"
              aria-selected="true"
            >
              Deudas Inmuebles
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className=" rounded nav-link bg-blue-200 text-light"
              disabled={
                operacion === 1 || operacion === 3 ? true : deshabilitado
              }
              id="deuda-tab"
              data-bs-toggle="tab"
              data-bs-target="#deuda"
              type="button"
              role="tab"
              aria-controls="deuda"
              aria-selected="false"
            >
              Historicos de Pagos de Inmuebles Urbanos
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className=" rounded nav-link bg-blue-300 text-light"
              disabled={
                operacion === 1 || operacion === 3 ? true : deshabilitado
              }
              id="hist-tab"
              data-bs-toggle="tab"
              data-bs-target="#historico"
              type="button"
              role="tab"
              aria-controls="historico"
              aria-selected="false"
            >
              Relacion de Facturas Contribuyente
            </a>
          </li>
          <button
            className="btn btn-sm btn-info rounded-pill col-md-2 ml-auto"
            onClick={imprimirRelacionPago("Planillacontricomercio")}
          >
            <i className="fas fa-print"> Pagos Web</i>{" "}
          </button>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="tributarios"
            role="tabpanel"
            aria-labelledby="datosTributarios"
          >
            <TablaDeudaInmueble
              tabDeuda={props.deuda}
              idinmueble={props.inmueble && props.inmueble.idinmueble}
              credito={props.credito && props.credito > 0 ? props.credito : 0.0}
              factorcambio={factorCambio && factorCambio > 0 ? factorCambio : 0.0}
            />
          </div>
          <div
            className="tab-pane fade"
            id="deuda"
            role="tabpanel"
            aria-labelledby="deuda-tab"
          >
            <TablaHistoricosInmuebles
              tabHis={props.historico}
              idinmueble={props.inmueble && props.inmueble.idinmueble}
            />
          </div>
          <div
            className="tab-pane fade"
            id="historico"
            role="tabpanel"
            aria-labelledby="hist-tab"
          >
            <TablaFacturasInmuebles facturaR={props.facturaR} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <InfoButton icon = 'fa-print'
          ref={btnAcepta}
          onClick={imprimirDeudaGeneral("Hac_DeudaGeneral")}
        >
          Imprimir Deuda General
        </InfoButton>
        <DangerButton 
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />

        <Dimmer active={activate} >
        </Dimmer>
    </Modal>
  );
};
